// import React, { useEffect, useState } from "react";
// import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   useMediaQuery,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   Box,
//   Typography,
// } from "@mui/material";

// import CryptoJS from "crypto-js";
// import { getDecryptedRefreshToken } from "../../LoginUserDetails.js/LoginUserSavedDetails";

// import ApiServices from "../../ApiServices/ApiServices";
// import ClientViewSidebar from "../../../Container/ClientViewSidebar/ClientViewSidebar";
// import RiteClientDetails from "../../../Components/RiteAdmin/RiteClients/RiteClientDetails";
// import ClientLocations from "../../../Components/RiteAdmin/RiteClients/ClientLocations/ClientLocations";
// import ClientEmailManager from "../../../Components/RiteAdmin/RiteClients/ClientEmails/ClientEmailManager";
// import ClientRcsManagement from "../../../Components/RiteAdmin/RiteClients/ClientRcs/ClientRcsManagement";
// import WebsiteManagement from "../../../Components/RiteAdmin/RiteClients/WebsiteManagement/WebsiteManagement";

// const SIDEBAR_BG = "#122b2a";
// const SIDEBAR_ACTIVE = "#1c7c6c";

// const ClientRoutes = () => {
//   const isMobile = useMediaQuery("(max-width:767px)");
//   const isTablet = useMediaQuery("(min-width:768px) and (max-width:1199px)");

//   const [sidebarWidth, setSidebarWidth] = useState(
//     isMobile ? 0 : isTablet ? 64 : 240,
//   );
//   const { clientId } = useParams();

//   const [showDialog, setShowDialog] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");

//   const navigate = useNavigate();
//   const location = useLocation();

//   const timeoutDuration = 30 * 60 * 1000; // 30 minutes

//   const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;

//   /* ================= REFRESH TOKEN FUNCTION ================= */

//   const refreshAccessToken = async () => {
//     try {
//       const refreshToken = getDecryptedRefreshToken();

//       if (!refreshToken) throw new Error("No refresh token");

//       const response = await ApiServices.post("/api/token/refresh/", {
//         refresh: refreshToken,
//       });

//       const newAccessToken = response.data.access;

//       sessionStorage.setItem(
//         "LoginUserAccessToken",
//         CryptoJS.AES.encrypt(newAccessToken, secretKey).toString(),
//       );

//       return newAccessToken;
//     } catch (error) {
//       sessionStorage.clear();
//       navigate("/provider-emr-login");
//       return null;
//     }
//   };

//   /* ================= SESSION TIMEOUT WARNING ================= */

//   useEffect(() => {
//     const timeout = setTimeout(
//       () => {
//         setShowDialog(true);
//       },
//       timeoutDuration - 5 * 60 * 1000,
//     ); // show warning 5 min before expiry

//     const resetTimeout = () => {
//       clearTimeout(timeout);
//       setShowDialog(false);
//     };

//     window.addEventListener("click", resetTimeout);
//     window.addEventListener("keypress", resetTimeout);

//     return () => {
//       clearTimeout(timeout);
//       window.removeEventListener("click", resetTimeout);
//       window.removeEventListener("keypress", resetTimeout);
//     };
//   }, [timeoutDuration]);

//   /* ================= AUTO REFRESH EVERY 60 MINUTES ================= */

//   useEffect(() => {
//     const interval = setInterval(
//       async () => {
//         const confirmRefresh = window.confirm(
//           "Your session will be refreshed to keep you logged in. Continue?",
//         );

//         if (confirmRefresh) {
//           await refreshAccessToken();
//         } else {
//           handleLogout();
//         }
//       },
//       60 * 60 * 1000,
//     );

//     return () => clearInterval(interval);
//   }, []);

//   /* ================= LOGOUT ================= */

//   const handleLogout = () => {
//     setLoading(true);

//     setTimeout(() => {
//       sessionStorage.clear();
//       navigate("/client-login");
//       setLoading(false);
//     }, 1000);
//   };

//   /* ================= CONTINUE SESSION ================= */

//   const handleContinueSession = async () => {
//     setLoading(true);

//     try {
//       const token = await refreshAccessToken();

//       if (token) {
//         setShowDialog(false);
//       } else {
//         throw new Error("Token refresh failed");
//       }
//     } catch {
//       setSnackbarMessage("Session renewal failed. Please login again.");
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= PAGE TITLE ================= */

//   const pageTitle =
//     location.pathname.split("/").filter(Boolean).pop() || "dashboard";

//   const formattedTitle = pageTitle
//     .replace(/-/g, " ")
//     .replace(/\b\w/g, (c) => c.toUpperCase());

//   return (
//     <Box
//       sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f8fafa" }}
//     >
//       {/* Sidebar */}
//       <ClientViewSidebar onSidebarChange={setSidebarWidth} />

//       {/* Main Area */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           ml: isMobile ? 0 : `${sidebarWidth}px`,
//           transition: "margin-left 0.3s ease",
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//           width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: "sticky",
//             top: 0,
//             zIndex: 10,
//             backgroundColor: "#fff",
//             borderBottom: "1px solid #e8eded",
//             px: { xs: 2, sm: 3 },
//             py: 1.5,
//             display: "flex",
//             alignItems: "center",
//             pl: isMobile ? 7 : { xs: 2, sm: 3 },
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//             <Typography
//               onClick={() => navigate("/rite-admin/dashboard")}
//               sx={{
//                 fontSize: 13,
//                 color: SIDEBAR_ACTIVE,
//                 cursor: "pointer",
//                 fontWeight: 500,
//                 "&:hover": { textDecoration: "underline" },
//               }}
//             >
//               Home
//             </Typography>

//             <Typography sx={{ fontSize: 13, color: "#999", mx: 0.5 }}>
//               ›
//             </Typography>

//             <Typography sx={{ fontSize: 13, color: "#333", fontWeight: 600 }}>
//               {formattedTitle}
//             </Typography>
//           </Box>
//         </Box>

//         {/* Page Routes */}
//         <Box sx={{ flex: 1, p: { xs: 2, sm: 3 }, overflow: "auto" }}>
//           <Routes>
//             <Route path="/:clientId/dashboard" element={<RiteClientDetails />} />
//             <Route path="/locations/:clientId" element={<ClientLocations/>} />
//             <Route path="/emails/:clientId" element={<ClientEmailManager />} />
//             <Route path="/rcs/:clientId" element={<ClientRcsManagement/>} />
//             <Route path="/websites/:clientId" element={<WebsiteManagement/>} />
//           </Routes>
//         </Box>
//       </Box>

//       {/* Session Dialog */}
//       <Dialog
//         open={showDialog}
//         PaperProps={{ sx: { borderRadius: 3, minWidth: 350 } }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, color: SIDEBAR_BG }}>
//           Session Expiring
//         </DialogTitle>

//         <DialogContent>
//           <DialogContentText>
//             Your session will expire in 5 minutes. Do you want to continue?
//           </DialogContentText>

//           {loading && (
//             <CircularProgress size={24} sx={{ mt: 2, color: SIDEBAR_ACTIVE }} />
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button
//             onClick={handleContinueSession}
//             variant="contained"
//             disabled={loading}
//             sx={{
//               borderRadius: 2,
//               backgroundColor: SIDEBAR_ACTIVE,
//               "&:hover": { backgroundColor: "#15635a" },
//             }}
//           >
//             Continue
//           </Button>

//           <Button
//             onClick={handleLogout}
//             variant="outlined"
//             disabled={loading}
//             sx={{
//               borderRadius: 2,
//               color: "#ef4444",
//               borderColor: "#ef4444",
//             }}
//           >
//             Log Out
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={4000}
//         onClose={() => setSnackbarOpen(false)}
//       >
//         <Alert
//           severity="error"
//           onClose={() => setSnackbarOpen(false)}
//           sx={{ borderRadius: 2 }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ClientRoutes;


import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, useMediaQuery, CircularProgress, Snackbar, Alert,
  Box, Typography, Breadcrumbs, Chip
} from "@mui/material";
import { Home, NavigateNext } from "@mui/icons-material";
import CryptoJS from "crypto-js";
import { getDecryptedRefreshToken } from "../../LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../ApiServices/ApiServices";
import ClientViewSidebar from "../../../Container/ClientViewSidebar/ClientViewSidebar";
import RiteClientDetails from "../../../Components/RiteAdmin/RiteClients/RiteClientDetails";
import ClientLocations from "../../../Components/RiteAdmin/RiteClients/ClientLocations/ClientLocations";
import ClientEmailManager from "../../../Components/RiteAdmin/RiteClients/ClientEmails/ClientEmailManager";
import ClientRcsManagement from "../../../Components/RiteAdmin/RiteClients/ClientRcs/ClientRcsManagement";
import WebsiteManagement from "../../../Components/RiteAdmin/RiteClients/WebsiteManagement/WebsiteManagement";
import ClientCustomers from "../../../Components/RiteAdmin/RiteClients/ClientCustomers/ClientCustomers";
import ClientOrders from "../../../Components/RiteAdmin/RiteClients/ClientOrders/ClientOrders";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const ClientRoutes = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1199px)");

  const [sidebarWidth, setSidebarWidth] = useState(isMobile ? 0 : isTablet ? 72 : 260);
  const { clientId } = useParams();

  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const timeoutDuration = 30 * 60 * 1000;
  const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;

  /* ========== REFRESH TOKEN ========== */

  const refreshAccessToken = async () => {
    try {
      const refreshToken = getDecryptedRefreshToken();
      if (!refreshToken) throw new Error("No refresh token");

      const response = await ApiServices.post("/api/token/refresh/", { refresh: refreshToken });
      const newAccessToken = response.data.access;

      sessionStorage.setItem(
        "LoginUserAccessToken",
        CryptoJS.AES.encrypt(newAccessToken, secretKey).toString()
      );
      return newAccessToken;
    } catch {
      sessionStorage.clear();
      navigate("/client-login");
      return null;
    }
  };

  /* ========== SESSION TIMEOUT ========== */

  useEffect(() => {
    let timeout;

    const startTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setShowDialog(true), timeoutDuration - 5 * 60 * 1000);
    };

    startTimeout();
    window.addEventListener("click", startTimeout);
    window.addEventListener("keypress", startTimeout);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("click", startTimeout);
      window.removeEventListener("keypress", startTimeout);
    };
  }, [timeoutDuration]);

  /* ========== AUTO REFRESH ========== */

  useEffect(() => {
    const interval = setInterval(async () => {
      const confirmRefresh = window.confirm("Your session will be refreshed to keep you logged in. Continue?");
      if (confirmRefresh) await refreshAccessToken();
      else handleLogout();
    }, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  /* ========== LOGOUT ========== */

  const handleLogout = () => {
    setLoading(true);
    setTimeout(() => {
      sessionStorage.clear();
      navigate("/client-login");
      setLoading(false);
    }, 1000);
  };

  const handleContinueSession = async () => {
    setLoading(true);
    try {
      const token = await refreshAccessToken();
      if (token) setShowDialog(false);
      else throw new Error("Token refresh failed");
    } catch {
      setSnackbarMessage("Session renewal failed. Please login again.");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  /* ========== BREADCRUMB ========== */

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const currentPage = pathSegments[pathSegments.length - 1] || "dashboard";
  const formattedTitle = currentPage.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f7fb" }}>
      <ClientViewSidebar onSidebarChange={setSidebarWidth} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: isMobile ? 0 : `${sidebarWidth}px`,
          transition: "margin-left 0.3s ease",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid #e8edf2",
            px: { xs: 2, sm: 3 },
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pl: isMobile ? 7 : { xs: 2, sm: 3 },
          }}
        >
          <Breadcrumbs separator={<NavigateNext sx={{ fontSize: 16, color: "#bbb" }} />} sx={{ fontSize: 13 }}>
            <Typography
              onClick={() => navigate(`/client-view/${clientId}/dashboard`)}
              sx={{
                fontSize: 13,
                color: accent,
                cursor: "pointer",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                "&:hover": { textDecoration: "underline" },
              }}
            >
              <Home sx={{ fontSize: 16 }} /> Home
            </Typography>
            <Chip
              label={formattedTitle}
              size="small"
              sx={{
                height: 24,
                fontSize: 12,
                fontWeight: 600,
                backgroundColor: accentLight,
                color: accent,
              }}
            />
          </Breadcrumbs>
        </Box>

        {/* Page Content */}
        <Box sx={{ flex: 1, p: { xs: 2, sm: 3 }, overflow: "auto" }}>
          <Routes>
            <Route path="/:clientId/dashboard" element={<RiteClientDetails />} />
            <Route path="/locations/:clientId" element={<ClientLocations />} />
            <Route path="/customers/:clientId" element={<ClientCustomers />} />
            <Route path="/orders/:clientId" element={<ClientOrders/>} />
            <Route path="/emails/:clientId" element={<ClientEmailManager />} />
            <Route path="/rcs/:clientId" element={<ClientRcsManagement />} />
            <Route path="/websites/:clientId" element={<WebsiteManagement />} />
          </Routes>
        </Box>
      </Box>

      {/* Session Dialog */}
      <Dialog open={showDialog} PaperProps={{ sx: { borderRadius: 3, minWidth: 380 } }}>
        <DialogTitle sx={{ fontWeight: 700, color: accent }}>
          ⏱ Session Expiring
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your session will expire in <strong>5 minutes</strong>. Would you like to continue working?
          </DialogContentText>
          {loading && <CircularProgress size={24} sx={{ mt: 2, color: accent }} />}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button
            onClick={handleContinueSession}
            variant="contained"
            disabled={loading}
            sx={{
              borderRadius: "10px",
              background: `linear-gradient(135deg, ${accent}, #1565c0)`,
              px: 3,
              "&:hover": { background: accent },
            }}
          >
            Continue Session
          </Button>
          <Button
            onClick={handleLogout}
            variant="outlined"
            disabled={loading}
            sx={{
              borderRadius: "10px",
              color: "#ef4444",
              borderColor: "#ef4444",
              "&:hover": { background: "rgba(239,68,68,0.05)", borderColor: "#dc2626" },
            }}
          >
            Log Out
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
        <Alert severity="error" onClose={() => setSnackbarOpen(false)} sx={{ borderRadius: 2 }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ClientRoutes;
